var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-list"},[(_vm.sortable)?_c('draggable',{attrs:{"value":_vm.value,"handle":_vm.dragHandle,"force-fallback":true,"group":"description","ghost-class":"ghost","drag-class":"dragger"},on:{"input":function($event){return _vm.$emit('reorder', $event)}}},[_vm._t("default")],2):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }